module.exports = __webpack_public_path__ + "media/images/version_merge/why_us_background_block_template-9dc8be9f3630d1e195d48b794e322848.svg";